import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "left-icon"
};
const _hoisted_2 = {
  class: "header-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "header-wrapper",
    style: _normalizeStyle({
      backgroundColor: $props.backgroundColor,
      color: $props.color
    })
  }, [_createElementVNode("div", {
    class: "header-left flex-center",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.backClick && $setup.backClick(...args))
  }, [$props.isShowLeft ? (_openBlock(), _createElementBlock("div", _hoisted_1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_2, _toDisplayString($props.title), 1), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "header-right"
  }, null, -1))], 4);
}